export default "__VITE_ASSET__BaF60$ro__"